import { useId, useState, type FormEvent } from 'react';
import { Dialog } from '@/shared/components/ui/Dialog';
import { useI18n } from '@/shared/i18n/useT';

interface Props {
  initialName: string;
  error?: string | null;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

export function RenameDialog({ initialName, error, onSubmit, onClose }: Props) {
  const { t } = useI18n();
  const fieldId = useId();
  const [name, setName] = useState(initialName);

  const trimmed = name.trim();

  function submit(event: FormEvent) {
    event.preventDefault();
    if (!trimmed) return;
    onSubmit(trimmed);
  }

  return (
    <Dialog
      title={t('folders.renameDialog.title')}
      error={error ?? null}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            className="tap-target rounded-full border border-border-strong px-4 text-sm text-fg"
          >
            {t('common.cancel')}
          </button>
          <button
            type="submit"
            form={fieldId}
            disabled={!trimmed}
            className="tap-target rounded-full bg-accent px-4 text-sm font-medium text-accent-fg disabled:opacity-50"
          >
            {t('common.save')}
          </button>
        </>
      }
    >
      <form id={fieldId} onSubmit={submit}>
        <label htmlFor={`${fieldId}-input`} className="mb-1 block text-sm text-muted">
          {t('folders.renameDialog.label')}
        </label>
        <input
          id={`${fieldId}-input`}
          value={name}
          onChange={(event) => setName(event.target.value)}
          maxLength={200}
          // The extension-less name is selected on open, the way every file
          // manager does it: renaming usually replaces the whole thing.
          autoFocus
          onFocus={(event) => event.currentTarget.select()}
          className="tap-target w-full rounded-full border border-border-strong bg-surface px-3 text-sm text-fg"
        />
      </form>
    </Dialog>
  );
}




